import { render, staticRenderFns } from "./issuesManagement.vue?vue&type=template&id=4c04ab49&scoped=true"
import script from "./issuesManagement.vue?vue&type=script&lang=js"
export * from "./issuesManagement.vue?vue&type=script&lang=js"
import style0 from "./issuesManagement.vue?vue&type=style&index=0&id=4c04ab49&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04ab49",
  null
  
)

export default component.exports